import type { ApiResponseInterface } from "@ts/interfaces/ApiResponseInterface";
import { post } from "./httpClient";

export const generateOTP = async (
  gradeCode: number
): Promise<ApiResponseInterface<void>> => {
  return await post("/user/change-grade/generate-otp", {
    grade: gradeCode
  });
};

export const validateOTP = async (
  otp: string
): Promise<ApiResponseInterface<void>> => {
  return await post("/user/update-current-grade", {
    otp
  });
};

export const gradeChangeApi = {
  generateOTP,
  validateOTP
};
